import React, { useEffect } from "react";
import { BranchSliderLinks } from "../../common/Links/branchSliderLinks";
import { Route, Routes, useParams } from "react-router-dom";
import Menus from "../../pages/menus";
import Categories from "../../pages/categories";
import Items from "../../pages/items";
import Options from "../../pages/options";
import Sort from "../../pages/sort";
import { indexStore } from "../../store/indexStore";
import Sidebar from "../SiderLayout/SiderBar";
import MobileNav from "../SiderLayout/MobileNav";
import Orders from "../OrdersBranch/Orders";
import NotificationManager from "../Notifications/NotificationManager";
import NotFound from "../pages/NotFound/NotFound";
import {
  collection,
  query,
  where,
  onSnapshot,
  orderBy,
  limit,
} from "firebase/firestore";
import database from "../../firebase";
import { OrderStatus } from "src/enums/orderStatus";

function BranchLayout() {
  const branchLinks = BranchSliderLinks();
  const branchLinksFilter = branchLinks.filter((link) => !link.hidden);
  const {
    fetchCategoriesAction,
    fetchMenusAction,
    status,
    featchBranchFunction,
    setNewOrderNotification,
    resetUnreadCount,
  } = indexStore();
  const { branchId } = useParams();
  useEffect(() => {
    if (branchId) {
      fetchMenusAction(branchId);
      fetchCategoriesAction(branchId);
      featchBranchFunction(branchId);
    }
  }, [branchId, fetchMenusAction, fetchCategoriesAction, featchBranchFunction]);
  // استماع للطلبات الجديدة فقط للإشعارات (محدود بـ 10 طلبات فقط)
  useEffect(() => {
    if (!branchId) return;

    const ordersRef = collection(database, "branches", branchId, "orders");

    // استعلام محدود: آخر 10 طلبات pending فقط
    const q = query(
      ordersRef,
      where("status", "==", OrderStatus.pending),
      orderBy("created_at", "desc"),
      limit(20) // تقليل عدد القراءات بشكل كبير
    );

    let isFirstLoad = true;
    let lastOrderIds = new Set();

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const pendingOrders = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      // تجاهل التحميل الأول - لا نريد إشعارات للطلبات الموجودة مسبقاً
      if (isFirstLoad) {
        isFirstLoad = false;
        lastOrderIds = new Set(pendingOrders.map((order) => order.id));
        return;
      }

      // فحص الطلبات الجديدة فقط (مقارنة بالـ IDs السابقة)
      const currentOrderIds = new Set(pendingOrders.map((order) => order.id));
      const newOrderIds = [...currentOrderIds].filter(
        (id) => !lastOrderIds.has(id)
      );

      // إشعار بالطلبات الجديدة فقط
      if (newOrderIds.length > 0) {
        const newOrders = pendingOrders.filter((order) =>
          newOrderIds.includes(order.id)
        );

        if (newOrders.length > 0) {
          // إشعار بالطلب الأحدث فقط
          const latestNewOrder = newOrders[0];
          setNewOrderNotification(latestNewOrder);
          indexStore.setState({ hasNewPending: true });
        }
      }

      lastOrderIds = currentOrderIds;
    });

    return () => unsubscribe();
  }, [branchId, setNewOrderNotification]);

  // تحديث قائمة الطلبات عند الانتقال إلى صفحة pending (فقط عند الحاجة)
  useEffect(() => {
    if (!branchId) return;

    // إيقاف الاستماع إذا لم يكن المستخدم في صفحة pending
    if (status !== OrderStatus.pending) {
      return;
    }

    // استخدام listener محدود فقط عند فتح صفحة pending
    const ordersRef = collection(database, "branches", branchId, "orders");
    const q = query(
      ordersRef,
      where("status", "==", OrderStatus.pending),
      orderBy("created_at", "desc"),
      limit(80) // حد أقصى 50 طلب للعرض
    );

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const pendingOrders = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      indexStore.setState({
        orders: pendingOrders,
        hasNewPending: false,
        unreadOrdersCount: 0,
      });
      resetUnreadCount();
    });

    return () => unsubscribe();
  }, [branchId, status, resetUnreadCount]);

  return (
    <div className="flex flex-col  min-h-screen  w-full  md:grid grid-cols-[220px_1fr] lg:grid-cols-[280px_1fr]">
      <div className="bg-backgroundConant md:sticky md:top-0 md:self-start">
        <Sidebar siderLinks={branchLinksFilter} />
        <MobileNav siderLinks={branchLinksFilter} />
      </div>

      <div className="p-5 bg-backgroundConant min-h-screen flex-1 overflow-auto">
        <Routes>
          {/* <Route path={`/`} element={<BranchHomePage />} /> */}
          <Route path={`/menus`} element={<Menus />} />
          <Route path={`/categories`} element={<Categories />} />
          <Route path={`/items`} element={<Items />} />
          <Route path={`/options`} element={<Options />} />
          <Route path={`/sort`} element={<Sort />} />
          <Route path={`/orders`} element={<Orders />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>

      <NotificationManager />
    </div>
  );
}

export default BranchLayout;

// useEffect(() => {
//   if (!branchId) return;

//   const ordersRef = collection(database, "branches", branchId, "orders");
//   const q = query(
//     ordersRef,
//     where("status", "==", OrderStatus.pending),
//     orderBy("created_at", "desc")
//   );

//   let isFirstLoad = true;
//   let lastOrderCount = 0;

//   const unsubscribe = onSnapshot(q, (snapshot) => {
//     const pendingOrders = snapshot.docs.map((doc) => ({
//       id: doc.id,
//       ...doc.data(),
//     }));

//     // تجاهل التحميل الأول - لا نريد إشعارات للطلبات الموجودة مسبقاً
//     if (isFirstLoad) {
//       isFirstLoad = false;
//       lastOrderCount = pendingOrders.length;
//       // تحديث قائمة الطلبات فقط
//       if (status === OrderStatus.pending) {
//         indexStore.setState({
//           orders: pendingOrders,
//           hasNewPending: false,
//           unreadOrdersCount: 0,
//         });
//       }
//       return;
//     }

//     // فحص الطلبات الجديدة فقط
//     if (pendingOrders.length > lastOrderCount) {
//       const newOrders = pendingOrders.slice(
//         0,
//         pendingOrders.length - lastOrderCount
//       );

//       // إشعار بالطلب الأحدث فقط
//       if (newOrders.length > 0) {
//         const latestNewOrder = newOrders[0];
//         setNewOrderNotification(latestNewOrder);
//         indexStore.setState({ hasNewPending: true });
//       }
//     }

//     lastOrderCount = pendingOrders.length;

//     // تحديث قائمة الطلبات إذا المستخدم في صفحة pending
//     if (status === OrderStatus.pending) {
//       indexStore.setState({
//         orders: pendingOrders,
//         hasNewPending: false,
//         unreadOrdersCount: 0,
//       });
//       resetUnreadCount();
//     }
//   });

//   return () => unsubscribe();
// }, [branchId, status, setNewOrderNotification, resetUnreadCount]);
